import { create } from 'zustand';

export interface Avviso {
  id: number;
  testo: string;
  tono: 'ok' | 'errore' | 'info';
}

interface StatoAvvisi {
  avvisi: Avviso[];
  mostra(testo: string, tono?: Avviso['tono']): void;
  rimuovi(id: number): void;
}

let contatore = 0;

/** Avvisi brevi (toast). Sempre con testo: mai solo colore (RNF-04). */
export const useAvvisi = create<StatoAvvisi>()((set) => ({
  avvisi: [],
  mostra: (testo, tono = 'info') => {
    contatore += 1;
    const id = contatore;
    set((s) => ({ avvisi: [...s.avvisi, { id, testo, tono }] }));
    setTimeout(() => set((s) => ({ avvisi: s.avvisi.filter((a) => a.id !== id) })), 4000);
  },
  rimuovi: (id) => set((s) => ({ avvisi: s.avvisi.filter((a) => a.id !== id) })),
}));
